import { IconButtonSizes } from '@primitives/IconButton/types';
import { IconSize } from '@icons/types';

import styles from '@primitives/SplitButton/SplitButton.module.scss';

export const variantIconColorMap = {
    primary: styles.primaryIconColor,
    secondary: styles.secondaryIconColor,
};

export const sizeToIconSizeMap: Record<IconButtonSizes, IconSize> = {
    small: 'xs',
    medium: 'sm',
    large: 'md',
};
